export const MARKDOWN_TOOLBAR_ITEMS = [
  { type: 'button', icon: 'mdi-format-bold', title: 'Negrito', action: 'bold' },
  {
    type: 'button',
    icon: 'mdi-format-italic',
    title: 'Itálico',
    action: 'italic',
  },
  {
    type: 'button',
    icon: 'mdi-format-strikethrough-variant',
    title: 'Riscado',
    action: 'strike',
  },
  { type: 'button', icon: 'mdi-code-tags', title: 'Código', action: 'code' },
  {
    type: 'button',
    icon: 'mdi-code-braces',
    title: 'Bloco de código',
    action: 'codeBlock',
  },
  {
    type: 'button',
    icon: 'mdi-format-quote-close',
    title: 'Citação',
    action: 'quote',
  },
  { type: 'divider' },
  {
    type: 'button',
    icon: 'mdi-format-header-1',
    title: 'Título H1',
    action: 'h1',
  },
  {
    type: 'button',
    icon: 'mdi-format-header-2',
    title: 'Título H2',
    action: 'h2',
  },
  {
    type: 'button',
    icon: 'mdi-format-header-3',
    title: 'Título H3',
    action: 'h3',
  },
  { type: 'divider' },
  {
    type: 'button',
    icon: 'mdi-format-list-bulleted',
    title: 'Lista',
    action: 'unordered',
  },
  {
    type: 'button',
    icon: 'mdi-format-list-numbered',
    title: 'Lista numerada',
    action: 'ordered',
  },
  {
    type: 'button',
    icon: 'mdi-table',
    title: 'Tabela',
    action: 'createTable',
  },
  { type: 'divider' },
  {
    type: 'button',
    icon: 'mdi-link-variant',
    title: 'Inserir link',
    action: 'link',
  },
  {
    type: 'button',
    icon: 'mdi-image-outline',
    title: 'Inserir imagem',
    action: 'image',
  },
]

export const TABLE_PICKER_CONFIG = {
  MAX_ROWS: 10,
  MAX_COLS: 10,
  MIN_ROWS: 1,
  MIN_COLS: 1,
}
